import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Modal from '../../../../../../components/Modal';
import TextInput from '../../../../../../components/TextInput';

import { addExtraGroup as addExtraGroupMutation } from '../../../../../../graphql/mutations';
import { Sheet } from '../AllergenModal/styled';
import { Field, ProductButtonContainer } from './style';
import Button from '../../../../../../components/Button';
import { HeaderSmall } from '../../../../../../components/Text';
import ToggleSwitch from '../../../../../../components/ToggleSwitch';
import { productCategories as productCategoriesQuery } from '../../../../../../graphql/queries';
import { isNullOrUndefined } from '@/utils/data';
import i18n from '@/utils/i18n';

function AddExtraGroupModal({ productId, onClose, storeId }) {
  const [values, setValues] = useState({
    name: '',
    default_extras: [],
    maximum_extras: 0,
    minimum_extras: 0,
    is_open: true,
  });
  const [addExtraGroup, { loading: updating }] = useMutation(
    addExtraGroupMutation,
  );

  // TODO: we should probably reuse this more
  function handleChange({ target }) {
    const { value, name } = target;
    const type = target.getAttribute('type');
    const stateName = target.getAttribute('data-state-name') || name;
    let formattedValue = null;
    if (value === '') {
      formattedValue = undefined;
    } else {
      formattedValue = type === 'number' ? +value : value;
    }

    if (type === 'checkbox') formattedValue = value === 'true';
    setValues({ ...values, [stateName]: formattedValue });
  }

  function handleAddNewExtraGroup() {
    addExtraGroup({
      variables: { product_id: productId, group_id: null, item: values },
      refetchQueries: [
        {
          query: productCategoriesQuery,
          variables: {
            id: storeId,
            filter: 'ALL',
          },
        },
      ],
      update: () => {
        onClose();
      },
    });
  }

  return (
    <Modal onClose={onClose}>
      <Sheet>
        <Field>
          <TextInput
            name="extra-group-name"
            data-state-name="name"
            value={values.name}
            onChange={handleChange}
            placeholder={i18n.t('Menu:extraGroupName')}
          />
        </Field>
        <Field>
          <TextInput
            name="minimum_extras"
            data-state-name="minimum_extras"
            value={
              isNullOrUndefined(values.minimum_extras)
                ? ''
                : values.minimum_extras
            }
            onChange={handleChange}
            placeholder={i18n.t('Menu:minExtras')}
            type="number"
          />
        </Field>
        <Field>
          <TextInput
            name="maximum_extras"
            data-state-name="maximum_extras"
            value={
              isNullOrUndefined(values.maximum_extras)
                ? ''
                : values.maximum_extras
            }
            onChange={handleChange}
            placeholder={i18n.t('Menu:maxExtras')}
            type="number"
          />
        </Field>
        <Field>
          <HeaderSmall>
            {i18n.t('Menu:drawerDefault', {
              state: values.is_open
                ? i18n.t('Menu:drawerDefaultStateOpen')
                : i18n.t('Menu:drawerDefaultStateClosed'),
            })}
          </HeaderSmall>
          <ToggleSwitch
            data-state-name="is_open"
            name="is_open"
            value={!!values.is_open}
            onChange={handleChange}
          />
        </Field>

        <ProductButtonContainer>
          <Button onClick={handleAddNewExtraGroup} loading={updating}>
            {i18n.t('Menu:addExtraGroup')}
          </Button>
        </ProductButtonContainer>
      </Sheet>
    </Modal>
  );
}

AddExtraGroupModal.propTypes = {
  productId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  storeId: PropTypes.string.isRequired,
};

export default AddExtraGroupModal;
